function WSInternalEvent(callback, e) {
  callback.call(this, e);
}

export default WSInternalEvent;
